import { useEffect, useState } from 'react';
import { getHKFromLocalByAccount } from '@web-mail/util';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const useGetTagHotkeys = (account) => {
    const [hkMap, setHkMap] = useState({});
    useMsgRenderCallback('mailMenuOper', ev => {
        const { eventStrData } = ev;
        if (eventStrData === 'reloadHotKey') {
            setHkMap(getHKFromLocalByAccount(account));
        }
    });
    useEffect(() => {
        setHkMap(getHKFromLocalByAccount(account));
    }, [account]);
    return hkMap;
};
export default useGetTagHotkeys;
